// extracted by mini-css-extract-plugin
export default {"scrollWrapper":"unseen_ownership-module___scrollWrapper___b738ba83","list":"unseen_ownership-module___list___d8fba8ad"};